/**
 * @description 商品模块路有
 */
export default [{
    path: '/product/info', //商品详情
    name: 'product_info',
    component: () => import('@/views/product/Info.vue'),
    meta: {
      title: '商品详情-油柑网'
    }
  }, {
    path: '/product/search', //搜索页
    name: 'product_search',
    component: () => import('@/views/product/Search.vue'),
    meta: {
      title: '搜索-油柑网',
      bodyColor: true
    }
  },
  {
    path: '/product/search/result', //商品搜索结果
    name: 'product_search_result',
    component: () => import('@/views/product/SearchResult.vue'),
    meta: {
      title: '搜索结果-油柑网',
    }
  },
  {
    path: '/product/category/result', //分类搜索结果
    name: 'product_category_result',
    component: () => import('@/views/product/CategoryResult.vue'),
    meta: {
      title: '分类结果-油柑网'
    }
  }
]